import { isInBrowser } from '../../common/utils/ssrUtils.js';
import type { AddedAddon } from '../../common/types/addon.js';
import type { AddressSearchResult } from '../../components/AddressSearch/AddressSearch.js';
import type {
  InstallationServiceAddOnSelection,
  YritystuplaOfferSelection,
} from '../../components/FixedBroadbandCheckout/FixedBroadbandCheckout.js';
import type { YritysWifiSelection } from '../../components/FixedBroadbandProductSelection/FixedBroadbandYritysWifiAddOn.js';
import type { OnlineModel } from '../../generated/api/onlineModel.js';
import type { IpAddressAddOnSelection } from '../../public/site/path/FixedBroadbandOrder/fixedBroadbandAddOnUtil.js';

export const FIXED_BROADBAND_ORDER_DRAFT_STORAGE_KEY = 'fixed-broadband-order-draft';

const EXPIRY_MS = 3_600_000; // 1 hour

export interface FixedBroadbandOrderDraft {
  savedAt: number;
  routerState: {
    selectedOfferCode: string;
    isMobileProduct: boolean;
    searchAddress: string;
    postalCode: string;
    previousUrl: string;
    disableHeader: boolean;
    fixedBroadbandOnlineModel: OnlineModel;
    mobileBroadbandOnlineModel: OnlineModel;
  };
  addressSearchResult: AddressSearchResult;
  checkoutStep: number;
  step1Selections?: {
    yritystuplaOffer: YritystuplaOfferSelection;
    yritysWifiSelection: YritysWifiSelection;
    installationServiceSelection: InstallationServiceAddOnSelection;
    ipAddressAddOnSelection: IpAddressAddOnSelection;
    isGFastDeviceIncluded: boolean;
    additionalAddOnSelections: AddedAddon[];
    campaignAutoSelect: boolean;
  };
}

export const saveFixedBroadbandOrderDraft = (draft: FixedBroadbandOrderDraft): void => {
  if (!isInBrowser()) {
    return;
  }
  localStorage.setItem(FIXED_BROADBAND_ORDER_DRAFT_STORAGE_KEY, JSON.stringify(draft));
};

export const getFixedBroadbandOrderDraft = (): FixedBroadbandOrderDraft | null => {
  if (!isInBrowser()) {
    return null;
  }
  const raw = localStorage.getItem(FIXED_BROADBAND_ORDER_DRAFT_STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as FixedBroadbandOrderDraft;
  } catch {
    return null;
  }
};

export const clearFixedBroadbandOrderDraft = (): void => {
  if (!isInBrowser()) {
    return;
  }
  localStorage.removeItem(FIXED_BROADBAND_ORDER_DRAFT_STORAGE_KEY);
};

export const isFixedBroadbandOrderDraftExpired = (draft: FixedBroadbandOrderDraft): boolean => {
  return draft.savedAt + EXPIRY_MS < Date.now();
};
